import React, { useContext, useState, useEffect } from 'react';
import { ClassroomContext } from '../../context/ClassroomContext';
import ClassroomAssignments from './ClassroomAssignments'; 
import { transformIframes } from '../../utils/utils';
import { Link } from 'react-router-dom'; 
import styles from './styles/ClassroomDashboard.module.css'; 


const ClassroomDashboard = () => {
    const { classroom, isTeacher } = useContext(ClassroomContext);
    const [announcements, setAnnouncements] = useState([]);

    useEffect(() => {
        if (classroom?.announcements) {
            
            setAnnouncements(classroom.announcements);
        } else {
            setAnnouncements([]);
        }
    }, [classroom]);

    const recentAnnouncements = [...announcements].slice(-3).reverse();
 
    const createMarkup = (htmlString) => {
        const processedHtml = transformIframes(htmlString || ""); 
        return { __html: processedHtml };
    };

    return (
        <div className={styles.dashboardContainer}>
            {/* --- Left Section: Announcements Preview --- */}
            <div className={styles.leftSection}>
                <h3 className={styles.sectionTitle}>Recent Announcements</h3>
                <div className={styles.announcementsPreview}>
                    {recentAnnouncements.length > 0 ? (
                        recentAnnouncements.map((announcement, index) => (
                            <div
                                key={announcement._id || index} 
                                
                                className={`
                                    ${styles.previewCard}
                                    ${index === 0 ? styles.previewCardLatest : styles.previewCardOlder}
                                `}
                            >
                                <div className={styles.cardHeader}>
                                    <span className={styles.username}>
                                        {announcement.poster?.username || 'Unknown User'}
                                    </span>
                                    {/* Maybe add timestamp here later if needed */}
                                </div>
                                <div
                                    className={styles.cardContent}
                                    dangerouslySetInnerHTML={createMarkup(announcement.text)}
                                />
                                {/* No options button or dropdown needed here */}
                            </div>
                        ))
                    ) : (
                        <p style={{ textAlign: 'center', color: 'var(--text-color-medium)' }}>
                            No announcements yet.
                        </p>
                    )}
                </div>

                {/* "View Older" Button - only show if more than 3 announcements exist */}
                {announcements.length > 3 && classroom?._id && (
                    <Link
                        to={`/my-classrooms/${classroom._id}/a`} 
                        className={styles.viewOlderButton} 
                    >
                        View Older Announcements
                    </Link>
                )}
            </div>

            {/* --- Right Section: Assignments --- */}
            <div className={styles.rightSection}>
                 <h3 className={styles.assignmentsTitle}>Assignments</h3>
                <ClassroomAssignments fromDashboard={true} />
            </div>
        </div>
    );
};

export default ClassroomDashboard;